import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../img/visma_white.svg';
import { CartContext } from '../../CartContext';

const isShoppingCartEnabled = process.env.REACT_APP_FEATURE_SHOPPING_CART === 'true';

export const Header = () => {
  let token = localStorage.getItem('token');
  let userType = localStorage.getItem('userType');
  const { count, refreshCart } = useContext(CartContext);

  useEffect(() => {
    // Only hit GET /cart when the feature is on, so a disabled cart makes no calls.
    if (isShoppingCartEnabled) {
      refreshCart();
    }
  }, [refreshCart]);

  return (
    <header
      className="navbar navbar-default"
      id="nc4navTopMain"
      role="navigation"
    >
      <div className="navbar-header">
        <div className="navbar-brand">
          <Link
            to="/users"
            role="button"
            aria-label="Kudos Shop"
            className="d-flex align-items-center justify-content-center"
          >
            <img src={logo} alt="Logo" width="100px" className="pr-8" />
            Kudos Shop
          </Link>
        </div>
      </div>
      <nav className="collapse navbar-collapse" aria-label="navbarNav">
        <ul className="nav navbar-nav nav-tabs navbar-right first-level d-flex justify-content-between">
          <li className="icon">
            <Link
              className="nav-item fl-menu-item"
              to="/"
              role="menuitem"
              aria-selected="false"
              title="Users"
            >
              <span
                aria-hidden="true"
                className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-users pr-8"
              ></span>
            </Link>
          </li>
          <li className="icon">
            <Link
              className="nav-item fl-menu-item has-children"
              to="/products"
              role="menuitem"
              aria-selected="true"
              title="Products"
            >
              <span
                aria-hidden="true"
                className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-list-view pr-8"
              ></span>
            </Link>
          </li>
          {isShoppingCartEnabled && (
            <li className="icon">
              <Link
                className="nav-item fl-menu-item has-children"
                to="/cart"
                role="menuitem"
                aria-selected="false"
                aria-label="Cart"
                title="Cart"
              >
                <span
                  aria-hidden="true"
                  className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-shopping-cart pr-8"
                ></span>
                {count > 0 && (
                  <span className="badge badge-primary" style={{ marginLeft: "-6px" }}>
                    {count}
                  </span>
                )}
              </Link>
            </li>
          )}
            <li className="icon">
              <Link
                className="nav-item fl-menu-item has-children"
                to="/transactions"
                role="menuitem"
                aria-selected="true"
                title="Transactions"
              >
                <span
                  aria-hidden="true"
                  className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-price pr-8"
                ></span>
              </Link>
            </li>
          <li className="icon">
            <Link
              className="nav-item fl-menu-item has-children"
              to="/my-requests"
              role="menuitem"
              title="My Requests"
            >
              <span
                aria-hidden="true"
                className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-storage pr-8"
              ></span>
            </Link>
          </li>
          {userType == 1 && (
            <li className="icon">
              <Link
                className="nav-item fl-menu-item has-children"
                to="/requests"
                role="menuitem"
                aria-selected="true"
                title="Requests"
              >
                <span
                  aria-hidden="true"
                  className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-alert pr-8"
                ></span>
              </Link>
            </li>
          )}
          {userType == 1 && (
            <li className="icon">
              <Link
                className="nav-item fl-menu-item has-children"
                to="/adminlog"
                role="menuitem"
                aria-selected="true"
                title="Admin History Log"
              >
                <span
                  aria-hidden="true"
                  className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-alarm pr-8"
                ></span>
              </Link>
            </li>
          )}
          {token !== null && token !== "" && (
            <li className="icon">
              <Link
                className="nav-item fl-menu-item has-children"
                to="/login"
                role="menuitem"
                aria-selected="true"
                title="Logout"
                onClick={() => {
                 localStorage.removeItem('token');
                 localStorage.removeItem('userType');
                }}
              >
                <span
                  aria-hidden="true"
                  className="vismaicon vismaicon-dynamic vismaicon-menu vismaicon-logout pr-8"
                ></span>
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </header>
  );
};
